import { Button } from 'rsuite';
import { AsyncCheckPill } from '../../../../../../../components';
import styles from './HistoryFilters.module.scss';
import { useHistoryFilters } from './useHistoryFilters';

export const HistoryFilters = () => {
  const { list: filters } = useHistoryFilters();

  return (
    <main className={styles.container}>
      <section className={styles.wrapper}>
        <div className={styles.content}>
          <div>
            {filters.map(filter => {
              return !filter.dataKey.match(/categoryLevel/) && <AsyncCheckPill key={filter.dataKey} {...filter} />;
            })}
          </div>
          <div>
            {filters.map(filter => {
              return filter.dataKey.match(/categoryLevel/) && <AsyncCheckPill key={filter.dataKey} {...filter} />;
            })}
          </div>
        </div>
        <Button
          className="filter-button"
          onClick={() => {
            filters.forEach(filter => {
              filter.onClean?.();
            });
          }}
        >
          Limpar filtros
        </Button>
      </section>
    </main>
  );
};
